import styled from 'styled-components';

export const ButtonGroup = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing[24],
  '> *': {
    flex: 1,
    display: 'grid',
    '&:first-child': {
      marginRight: theme.spacing[8],
    },
  },
}));
